import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import { editWriteOffActItem } from '../../../../../store/writeOffSlice'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { editWriteOffctItemServiceLifeAPI } from '../../../../../api/writeOff/writeOffActItemAPI'
import MyButton from '../../../../UI/form/MyButton'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import TextFieldMain from '../../../../form/fields/TextFieldMain'

const ChangeServiceLifeForm = ({ writeOffActItemBd, setOpen }) => {

	const dispatch = useDispatch()

    const [data, setData] = useState(
        writeOffActItemBd ? 
            {
                serviceLife: writeOffActItemBd.serviceLife,
            } 
        : {}
    ) // Дані з форми

    // console.log('data', data)
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()
        const dataForBd = getDataForBd()

        setError('')
        setLoading(true)

        editWriteOffctItemServiceLifeAPI(dataForBd).then(data => {
            if (data) {
                dispatch(editWriteOffActItem(data))
            }

            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const getDataForBd = () => {
        const dataForBd = {
            id: writeOffActItemBd.id,
            serviceLife: data.serviceLife,
        }

        return dataForBd
    }

  return (
    <div className='myFormSimple'>
        {
			formDataProductIsField('serviceLife', 'writeOffActItem') ?
				<TextFieldMain
					required={formDataProductRequiredField('serviceLife', 'writeOffActItem')}
					setValidate={e => updateValidate(setValid, 'serviceLife', e)}
					setValueForm={e => setValueForm(setData, 'serviceLife', e)}
					forciblyValue={data && data.serviceLife ? data.serviceLife : ''}
                    label='Строк служби'
                    placeholder='Введіть cтрок служби'
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default ChangeServiceLifeForm